import React from 'react';
import { DEFAULT_APP_LANGUAGE } from '../Constants';


const initialState = {
    bigMenu: true,
    isAuthenticated: false,
    selectedLanguage: DEFAULT_APP_LANGUAGE,
    connectedUser: {},
    toggleMenu: () => { },
    setUserData: () => { },
    logout: () => { }
};

export default React.createContext(initialState);